import React, { useState } from 'react';
import { Business, ExpandMore, VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { AccordionDetails, AccordionSummary, Box, Grid, Typography, useTheme } from '@mui/material';

import { ReactComponent as BuildingMenuSvg } from 'assets/images/menu_building.svg';
import { IBuildingTreeItemAction, IBuildingVisualization } from 'models';
import { EnhancedAccordion } from 'components/styled-mui';
import { BuildingTreeItemHeader } from '.';
import { BuildingSelectDialog } from 'dialogs/building';

interface BuildingTreeBuildingItemProps {
  building: IBuildingVisualization;
  visibleFloors: boolean;
  setVisibleFloors: (value: boolean) => void;
}

export const BuildingTreeBuildingItem = ({
  building,
  visibleFloors,
  setVisibleFloors,
}: BuildingTreeBuildingItemProps) => {
  const theme = useTheme();
  const [visibleBuildingSelectDialog, setVisibleBuildingSelectDialog] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<boolean>(true);

  const icon = <BuildingMenuSvg />;
  const title = 'Building';
  const actions: Array<IBuildingTreeItemAction> = [
    {
      tooltip: 'Change Building',
      icon: <Business style={{ fontSize: 16 }} />,
      onClick: () => {
        setVisibleBuildingSelectDialog(true);
      },
    },
    {
      tooltip: visibleFloors ? 'Hide Floors' : 'Show Floors',
      icon: visibleFloors ? (
        <VisibilityOffOutlined style={{ fontSize: 16 }} />
      ) : (
        <VisibilityOutlined style={{ fontSize: 16 }} />
      ),
      onClick: () => setVisibleFloors(!visibleFloors),
    },
    // {
    //   tooltip: 'Show all disabled floors',
    //   icon: <VisibilityOutlined fontSize="inherit" />,
    //   // icon: <VisibilityOff fontSize="inherit" />,
    //   onClick: () => {},
    // },
    // {
    //   tooltip: 'Show all enabled floors',
    //   icon: <Visibility fontSize="inherit" />,
    //   // icon: <VisibilityOff fontSize="inherit" />,
    //   onClick: () => {},
    // },
    // {
    //   tooltip: 'Expand all floors',
    //   icon: <UnfoldMore fontSize="inherit" />,
    //   // icon: <UnfoldLess fontSize="inherit" />,
    //   onClick: () => {},
    // },
  ];

  return (
    <>
      <EnhancedAccordion defaultExpanded expanded={expanded} dividerColor={`${theme.palette.primary.light}60`}>
        <AccordionSummary expandIcon={<ExpandMore color="primary" />} onClick={() => setExpanded((prev) => !prev)}>
          <BuildingTreeItemHeader icon={icon} title={title} actions={actions} />
        </AccordionSummary>

        <AccordionDetails>
          <Box sx={{ paddingBottom: 2 }}>
            <Grid container rowSpacing={2} columnSpacing={4}>
              <Grid item xs={12} sm={4} md={12} container spacing={2}>
                <Grid item xs={12}>
                  <img
                    src={building.thumbnail}
                    loading="lazy"
                    alt={building.location}
                    style={{ width: '100%', height: 160, borderRadius: 4, objectFit: 'cover' }}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={8} md={12} container spacing={2}>
                <Grid item xs={3}>
                  <Typography variant="body2" color="textSecondary">
                    Address:
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  <Typography variant="body2" color="primary">
                    {building.location}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="body2" color="textSecondary">
                    Floors:
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  <Typography variant="body2" color="primary">
                    {building.floorsCount}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="body2" color="textSecondary">
                    Zones:
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  <Typography variant="body2" color="primary">
                    {building.totalZonesCount} (Total)
                  </Typography>
                </Grid>

                <Grid item xs={3} />

                <Grid item xs={9}>
                  <Typography variant="body2" color="primary">
                    {building.activeZonesCount} (Active)
                  </Typography>
                </Grid>

                <Grid item xs={3} />

                <Grid item xs={9}>
                  <Typography variant="body2" color="primary">
                    {building.pendingZonesCount} (Pending)
                  </Typography>
                </Grid>

                <Grid item xs={3} />

                <Grid item xs={9}>
                  <Typography variant="body2" color="primary">
                    {building.inactiveZonesCount} (Inactive)
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </EnhancedAccordion>

      <BuildingSelectDialog
        visible={visibleBuildingSelectDialog}
        setVisible={setVisibleBuildingSelectDialog}
        buildingId={building.id}
      />
    </>
  );
};
